import {getLocale} from "@/helpers/localeHelper.ts";

export function getSeparators() {
  const parts = new Intl.NumberFormat(getLocale().localeIntl).formatToParts(1234567.89);
  const decimal = parts.find(p => p.type === "decimal")?.value ?? ",";
  const group = parts.find(p => p.type === "group")?.value ?? ".";
  return {decimal, group};
}

export function localizedNumberFormatter(value: number | string | undefined | null) {
  const {decimal, group} = getSeparators();

  if (value === null || value === undefined) return "";

  const raw = `${value}`;
  if (raw === "") return "";
  if (raw === "-") return "-";

  const sign = raw.startsWith("-") ? "-" : "";
  const unsigned = sign ? raw.slice(1) : raw;

  // Internally we normalize decimals to ".", but we display the locale decimal.
  const hasTrailingDot = unsigned.endsWith(".");
  const [intPartRaw, fracPartRaw] = unsigned.split(".", 2);

  const intPart = `${intPartRaw ?? ""}`.replace(/\B(?=(\d{3})+(?!\d))/g, group);

  if (hasTrailingDot) return `${sign}${intPart}${decimal}`;
  if (fracPartRaw !== undefined && fracPartRaw !== "") return `${sign}${intPart}${decimal}${fracPartRaw}`;
  return `${sign}${intPart}`;
}